import Button from '@alltrails/shared/denali/components/Button';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import CustomProvider from 'components/CustomProvider';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import * as styles from './connectButtonStyles.module.scss';

const createReactClass = require('create-react-class');

const BaseConnectGoogleButton = createReactClass({
  getInitialState() {
    return {
      googlePlusId: this.props.googlePlusId
    };
  },
  componentDidMount() {
    //   a bit of a hack to call GAPI attachment in React on load
    window.handleGoogleClientLoad = function () {
      ServerCommunicationUtil.initGoogle(this.googleSuccessCallback);
    }.bind(this);
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/platform.js?onload=handleGoogleClientLoad';
    script.async = true;
    document.body.appendChild(script);
  },
  googleSuccessCallback(googleUser) {
    const token = googleUser.getAuthResponse().id_token;
    const data = { google_token: token };
    ServerCommunicationUtil.postApiEndpoint(
      '/api/alltrails/google/login',
      data,
      function (data, status, xhr) {
        this.setState({ googlePlusId: token });
      }.bind(this),
      console.error,
      function () {}
    );
  },
  handleUnlinkClick() {
    ServerCommunicationUtil.postApiEndpoint(this.props.unlinkPath, {});
  },
  render() {
    let button;
    if (this.state.googlePlusId) {
      button = (
        <li className="mark no-underline">
          <form id="connect-google-form" className={styles.connectButton} onSubmit={this.handleUnlinkClick}>
            <FormattedMessage defaultMessage="Connected" />
            <Button text={<FormattedMessage defaultMessage="Unlink" />} type="submit" size="sm" variant="destructive" />
          </form>
        </li>
      );
    } else {
      button = (
        <a className="account-settings flat-google-btn google" data-testid="connect-with-google">
          <div>
            <span>
              <FormattedMessage defaultMessage="Connect with Google" />
            </span>
          </div>
        </a>
      );
    }
    return <ul className="sidebar-header">{button}</ul>;
  }
});

const ConnectGoogleButton = props => {
  return (
    <CustomProvider>
      <BaseConnectGoogleButton {...props} />
    </CustomProvider>
  );
};

export { ConnectGoogleButton };
